import utils from '@/plugins/TravellerUtils';
import timeUtil from '@/util/timeUtils.js'

const stop = {
    namespaced: true,
    state: {
        stopList:[],
        selectedStop: null,
        stopMap: new Map()
    },
    mutations: {
        updateStopList(state , newList ) {
            state.stopList = newList
            state.stopList.forEach( stop => {
              state.stopMap.set(stop.tunnus, stop);
          });
        },
        updateSelectedStop(state , newStop ) {
            state.selectedStop = newStop
        }
    },
    actions: {
        getStopList( context ) {
          return new Promise((resolve , reject) => {
            this._vm.$traveller_http.get('/traveller/restui/timetables/stop/getPysakit')
              .then ( response => {
                if( utils.checkResponseIsArray(response) ) {
                  context.commit('updateStopList' , response.data );
                  resolve(response.data);
                } else {
                  reject("Could not update stop list");
                }
              }).catch( error => {
                reject(error);
              })
          });
        },  
        updateStop(context , newStop ) {
          return new Promise((resolve , reject) => {
            this._vm.$traveller_http.post('/traveller/restui/timetables/stop/savePysakki',newStop)
              .then ( response => {
                if( response.status == 200 ) {
                  context.dispatch('getStopList');
                  resolve(response);
                } else {
                  reject("Could not update stop");
                }
              }).catch( error => {
                reject(error);
              })
          });

        },
        deleteStop(context , stopId ) {
          return new Promise((resolve , reject ) => {
            this._vm.$traveller_http.delete(`/traveller/restui/timetables/stop/deletePysakki?tunnus=${stopId}`)
            .then(response => {
              if( response.status == 200 )
                context.dispatch('getStopList');
              resolve(response)
              context.commit('updateSelectedStop' , null )
            } ).catch( error => {
              reject(error)
            } )
          })
        },
        getStopDepartures( context, stopTunnus ) {
          return new Promise((resolve , reject) => {
            const start = timeUtil.startOfDayMoment()
            const end = timeUtil.endOfDayMoment()
            this.loading = true;
            
            const params = { 
                params: {
                    "stopTunnus" : stopTunnus,
                    "start": start.format(),
                    "end" : end.format()
                }
            }
            this._vm.$traveller_http.get('/traveller/restui/timetables/stop/getDeparturesForStopBetween', params )
              .then ( response => {
                if( utils.checkResponseIsArray(response) ) {
                  resolve(response.data);
                } else {
                  reject("Could not get departures for stop");
                }
              }).catch(error => {
                reject(error)
              });
          });
        },  
    }
}

export default stop;
